export const randomString = (length = 6) => {
    return Math.random().toString(20).substr(2, length);
};

export const capitalizeFirstLetterString = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
};

export const isNumber = (num) => {
    return (typeof num == 'string' || typeof num == 'number') && !isNaN(num - 0) && num !== '';
};

/**
 * Encode a string of text as base64
 *
 * @param data The string of text.
 * @returns The base64 encoded string.
 */
export const encodeBase64 = (data) => {
    let retValue;
    if (typeof btoa === "function") {
        retValue = btoa(data)
    } else if (typeof Buffer === "function") {
        retValue = Buffer.from(data, "utf-8").toString("base64");
    } else {
        throw new Error("Failed to determine the platform specific encoder");
    }
    return retValue.replace(/\+/g, '-').replace(/\//g, '_');
}

/**
 * Decode a string of base64 as text
 *
 * @param data The string of base64 encoded text
 * @returns The decoded text.
 */
export const decodeBase64 = (data) => {
    let retValue = data.replace(/-/g, '+').replace(/_/g, '/');
    if (typeof atob === "function") {
        retValue = atob(retValue);
    } else if (typeof Buffer === "function") {
        retValue = Buffer.from(retValue, "base64").toString("utf-8");
    } else {
        throw new Error("Failed to determine the platform specific decoder");
    }
    return retValue;
}

export const escapeRegExp = (string) => {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}
const MAX_MOBILE_STING_LENGTH = 45;
export const truncateStringIfMobile = (string, isMobile = null) => {
    if (isMobile && string.length > MAX_MOBILE_STING_LENGTH) {
        return string.substring(0, MAX_MOBILE_STING_LENGTH) + '...';
    }
    return string;
}

export const replaceAll = (str, match, replacement) => {
    return str.replace(new RegExp(escapeRegExp(match), 'g'), () => replacement);
}

export const isDebug = () => {
    if (typeof window.debugfSSPA === "undefined") {
        window.debugfSSPA = window.env.APP_ENV !== 'production' || window.location.search.indexOf('debugf=') !== -1;
    }
    return window.debugfSSPA;
}

export const debugf = (msg, details = '', justLogDataAfter = null) => {
    if (isDebug()) {
        console.log(
            typeof msg === 'object' && Array.isArray(msg) ? msg.filter(v => v !== '').join("\n \t - ") : msg,
            (details !== '' ? `\n \t - ${JSON.stringify(details)}` : ''),
            "\n\n"
        );
        Boolean(justLogDataAfter) && console.log(justLogDataAfter);
    }
}